import React from 'react';

export const SoundLogo = ({ color }: { color: 'black' | 'white' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={40} height={40} fill="none">
    <path
      fill={color === 'black' ? '#0E1213' : '#fff'}
      d="M0 20C0 8.954 8.954 0 20 0s20 8.954 20 20-8.954 20-20 20S0 31.046 0 20Z"
    />
    <path
      fill={color === 'black' ? '#fff' : '#0E1213'}
      d="M29.6 18.285c.22 0 .4-.18.4-.4v-4.6c0-.22-.18-.4-.4-.4H28c-.22 0-.4-.18-.4-.4v-1.6c0-.22-.18-.4-.4-.4H12.8c-.22 0-.4.18-.4.4v1.6c0 .22-.18.4-.4.4h-1.6c-.22 0-.4.18-.4.4v6.6c0 .22.18.4.4.4h5.2c.22 0 .4.18.4.4v1.2c0 .22.18.4.4.4h7.2c.22 0 .4.18.4.4v4.2c0 .22-.18.4-.4.4h-4.2c-.22 0-.4-.18-.4-.4v-1.8c0-.22-.18-.4-.4-.4h-4.2c-.22 0-.4-.18-.4-.4v-1.2c0-.22-.18-.4-.4-.4h-3.2c-.22 0-.4.18-.4.4v4.6c0 .22.18.4.4.4H12c.22 0 .4.18.4.4v1.6c0 .22.18.4.4.4h14.4c.22 0 .4-.18.4-.4v-1.6c0-.22.18-.4.4-.4h1.6c.22 0 .4-.18.4-.4v-6.6c0-.22-.18-.4-.4-.4h-5.2c-.22 0-.4-.18-.4-.4v-1.2c0-.22-.18-.4-.4-.4h-7.2c-.22 0-.4-.18-.4-.4v-4.2c0-.22.18-.4.4-.4h4.2c.22 0 .4.18.4.4v1.8c0 .22.18.4.4.4h4.2c.22 0 .4.18.4.4v1.2c0 .22.18.4.4.4h3.2Z"
    />
  </svg>
);
